import type { TrailerListQuery } from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import { COMPLIANCE_LABELS } from '../../../../../shared/features/compliance-documents/policies/document-status-labels';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { TrailerListItem } from '../trailers.api';
import { fleetRecordPath } from '../../../fleet.paths';

interface BuildTrailerColumnsArgs {
  list: Pick<ListQueryControls<TrailerListQuery>, 'sortOrderFor' | 'filteredValueFor'>;
}

const STATUS_FILTERS = [
  { text: 'Active', value: 'active' },
  { text: 'Inactive', value: 'inactive' },
];

/** Sorting and filtering run on the server: each column's `key` is its `sort` field or filter param in `trailerListQuerySchema`. */
export function buildTrailerColumns({ list }: BuildTrailerColumnsArgs): TableColumnsType<TrailerListItem> {
  return [
    {
      title: 'Registration',
      dataIndex: 'registration',
      key: 'registration',
      sorter: true,
      sortOrder: list.sortOrderFor('registration'),
      render: (registration: string, trailer) => (
        <Link className="font-mono text-sm font-medium text-link hover:underline" to={fleetRecordPath('trailers', trailer.id)}>
          {registration}
        </Link>
      ),
    },
    { title: 'Type', dataIndex: 'typeCode', key: 'typeCode', render: (typeCode: string) => <span className="font-mono text-xs">{typeCode}</span> },
    { title: 'Capacity (t)', dataIndex: 'capacityTonnes', key: 'capacityTonnes' },
    { title: 'Axles', dataIndex: 'axleCount', key: 'axleCount' },
    {
      title: 'Status',
      key: 'status',
      filters: STATUS_FILTERS,
      filteredValue: list.filteredValueFor('status'),
      render: (_, trailer) => <Tag color={trailer.isActive ? 'success' : 'default'}>{trailer.isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: 'Compliance',
      key: 'compliance',
      render: (_, trailer) => <Tag color={COMPLIANCE_LABELS[trailer.compliance].color}>{COMPLIANCE_LABELS[trailer.compliance].label}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, trailer) => (
        <Link className="text-sm font-medium text-link hover:underline" to={fleetRecordPath('trailers', trailer.id)}>
          View
        </Link>
      ),
    },
  ];
}
